import { NotificationsService } from "angular2-notifications";
import { Client, ClientType } from "./comEnvironmentClient";
import {
  Notifications,
  NotificationsDefault,
} from "./comEnvironmentNotifications";
import { NotificationsCordova } from "./comEnvironmentNotificationsCordova";
import { Geolocation, GeolocationDefault } from "./comEnvironmentGeolocation";
import { CoreLanguageService } from "../language.service";
import { CoreLogService } from "../log.service";
import { Media, MediaDefault } from "./comEnvironmentMedia";
import { IFileSystem, FileSystemDefault } from "./comEnvironmentFileSystem";
import { Events, EventsDefault } from "./comEnvironmentEvents";
import { Trigger, TriggerDefault } from "./comEnvironmentTrigger";
// todo entfernt da es ein zirkelbezug ergibt import { Storage, StorageDefault } from "./comEnvironmentStorage";
import { Loader, LoaderDefault } from "./comEnvironmentLoader";
import {
  Splashscreen,
  SplashscreenDefault,
} from "./comEnvironmentSplashscreen";
import { PhoneCall, PhoneCallDefault } from "./comEnvironmentPhoneCall";
import {
  Brightness,
  BrightnessDefault,
  BrightnessCordova,
} from "./comEnvironmentBrightness";
import {
  FirebaseMessaging,
  IFirebaseCloudMessaging,
} from "./comEnvironmentFirebaseCloudMessaging";
import {
  NetworkInformation,
  NetworkInformationDefault,
} from "./comEnvironmentNetworkInformation";
import { ValueStorageService } from "../valueStorage.service";
import { Injector, NgZone } from "@angular/core";
import Utils from "../../shared/utils";
import { ICordovaStatusBar, CordovaStatusBar } from "./comEnvironmentStatusBar";
import {
  ICordovaNavigationBar,
  CordovaNavigationBar,
} from "./comEnvironmentNavigationBar";
import { IIndexedDB, IndexedDBDefault } from "./comEnvironmentIndexedDB";
import { IQRCodeScanner, QRCodeScanner } from "./comEnvironmentQRCodeScanner";
import { Diagnostic, IDiagnostic } from "./comEnvironmentDiagnostic";

/** UAPP CoreCOM Environment */
export class comEnvironment {
  private _notification: Notifications;
  private _client: Client;
  private _geolocation: Geolocation;
  private _media: Media;
  private _fileSystem: IFileSystem;
  private _events: Events;
  private _trigger: Trigger;
  // todo entfernt da es ein zirkelbezug ergibt private _storage: Storage;
  private _valueStorage: ValueStorageService;
  private _indexedDB: IIndexedDB;
  private _loader: Loader;
  private _networkInformation: NetworkInformation;
  private _splashscreen: Splashscreen;
  private _phoneCall: PhoneCall;
  private _brightness: Brightness;
  private _statusBar: ICordovaStatusBar;
  private _firebaseCloudMessaging: IFirebaseCloudMessaging;
  private _navigationBar: ICordovaNavigationBar;
  private _qrCodeScanner: IQRCodeScanner;
  private _diagnostic: IDiagnostic;

  /** comEnvironment */
  constructor(
    private _notificationsService: NotificationsService,
    private _coreLogService: CoreLogService,
    private _ngZone: NgZone,
    private _injector: Injector
  ) {
    // set client
    this._determineClientType();
    // this._setNotification - against circular dependency
    this._setMedia(new MediaDefault(this._coreLogService));
    this._setFileSystem(new FileSystemDefault(this._coreLogService));
    this._setIndexedDB(new IndexedDBDefault(this._coreLogService));
    this._setLoader(new LoaderDefault(this._coreLogService));
    // this._setValueStorage - against circular dependency
    this._setTrigger(new TriggerDefault(this._coreLogService));
    this._setEvents(new EventsDefault(this._coreLogService, this._ngZone));
    this._setGeolocation(new GeolocationDefault(this._coreLogService));
    this._setNetworkInformation(new NetworkInformationDefault(this._coreLogService));
    this._setSplashscreen(new SplashscreenDefault(this._coreLogService));
    this._setPhoneCall(new PhoneCallDefault(this._coreLogService));
    this._setFirebaseCloudMessaging(new FirebaseMessaging(this._coreLogService, this._client));

    if (this.client.type === ClientType.android || this.client.type === ClientType.ios) {
      this._setBrightness(new BrightnessCordova(this._coreLogService));
      this._setStatusBar(new CordovaStatusBar(this._coreLogService));
    } else {
      this._setBrightness(new BrightnessDefault(this._coreLogService));
    }

    if (this.client.type === ClientType.android) {
      this._setNavigationBar(new CordovaNavigationBar(this._coreLogService));
    }
    this.events.deviceReady.subscribe(() => {
      console.log("QRCodeScanner is Initialized");
      this._setQRCodeScanner(new QRCodeScanner(this._coreLogService));
      this._setDiagnostic(new Diagnostic(this._coreLogService));
    });
  }

  /** Nachrichten ausgeben */
  public get notification(): Notifications {
    // initial by call, against circular dependency
    if (Utils.IsNull(this._notification)) {
      // es sollte auch ohne Mutex/SyncLock funktionieren
      if (
        this.client.type === ClientType.android ||
        this.client.type === ClientType.ios ||
        this.client.type === ClientType.windows
      ) {
        this._notification = new NotificationsCordova(
          this._notificationsService,
          this._injector.get(CoreLanguageService),
          this.client,
          this._coreLogService
        );
      } else {
        this._notification = new NotificationsDefault(
          this._notificationsService,
          this._injector.get(CoreLanguageService),
          this.client,
          this._coreLogService
        );
      }
    }
    return this._notification;
  }

  /** Clientinformationen */
  public get client(): Client {
    return this._client;
  }
  private _setClient(value: Client) {
    this._client = value;
  }

  /** Geolokalisierung  */
  public get geolocation(): Geolocation {
    return this._geolocation;
  }
  private _setGeolocation(value: Geolocation) {
    this._geolocation = value;
  }

  /** Media */
  public get media(): Media {
    return this._media;
  }
  private _setMedia(value: Media) {
    this._media = value;
  }

  /** FileSystem */
  public get fileSystem(): IFileSystem {
    return this._fileSystem;
  }
  private _setFileSystem(value: IFileSystem) {
    this._fileSystem = value;
  }

  /** Plattformevents */
  public get events(): Events {
    return this._events;
  }
  private _setEvents(value: Events) {
    this._events = value;
  }

  /** Trigger */
  public get trigger(): Trigger {
    return this._trigger;
  }
  private _setTrigger(value: Trigger) {
    this._trigger = value;
  }

  /** ValueStorage */
  public get valueStorage(): ValueStorageService {
    // initial by call, against circular dependency
    if (Utils.IsNull(this._valueStorage)) {
      // es sollte auch ohne Mutex/SyncLock funktionieren
      this._valueStorage = this._injector.get(ValueStorageService);
    }
    return this._valueStorage;
  }

  /** IndexedDB */
  public get indexedDB(): IIndexedDB {
    return this._indexedDB;
  }
  private _setIndexedDB(value: IIndexedDB) {
    this._indexedDB = value;
  }

  /** Loader */
  public get loader(): Loader {
    return this._loader;
  }
  private _setLoader(value: Loader) {
    this._loader = value;
  }

  /** NetworkInformation */
  public get networkInformation(): NetworkInformation {
    return this._networkInformation;
  }
  private _setNetworkInformation(value: NetworkInformation) {
    this._networkInformation = value;
  }

  /** Splashscreen */
  public get splashscreen(): Splashscreen {
    return this._splashscreen;
  }
  private _setSplashscreen(value: Splashscreen) {
    this._splashscreen = value;
  }

  /** PhoneCall */
  public get phoneCall(): PhoneCall {
    return this._phoneCall;
  }
  private _setPhoneCall(value: PhoneCall) {
    this._phoneCall = value;
  }

  /** Brightness */
  public get brightness(): Brightness {
    return this._brightness;
  }
  private _setBrightness(value: Brightness) {
    this._brightness = value;
  }

  /** StatusBar */
  public get statusBar(): ICordovaStatusBar {
    return this._statusBar;
  }
  private _setStatusBar(value: ICordovaStatusBar) {
    this._statusBar = value;
  }

  /** FirebaseCloudMessaging */
  public get firebaseCloudMessaging(): IFirebaseCloudMessaging {
    return this._firebaseCloudMessaging;
  }
  private _setFirebaseCloudMessaging(value: IFirebaseCloudMessaging) {
    this._firebaseCloudMessaging = value;
  }

  // Helper functions

  /** Clienttype herausfinden und festlegen */
  private _determineClientType(
    platform: string = null,
    manufacturer: string = null,
    model: string = null
  ) {
    this._setClient(new Client(platform, manufacturer, model));
  }

  /** faket beim Aufrufen ein Clienttyp, nur wenn es nicht in Cordova läuft */
  public fakseClientType(platform: string) {
    this._determineClientType(platform);
  }

  /** faket den dateizugriff, nur wenn es nicht in Cordova läuft */
  public fakeFileSystem(fileSystem: IFileSystem) {
    if (typeof window === "undefined") {
      this._setFileSystem(fileSystem);
    }
  }

  /** NavigationBar */
  public get navigationBar(): ICordovaNavigationBar {
    return this._navigationBar;
  }

  private _setNavigationBar(value: ICordovaNavigationBar) {
    this._navigationBar = value;
  }

  public get QRCodeScanner(): IQRCodeScanner {
    return this._qrCodeScanner;
  }

  private _setQRCodeScanner(value: IQRCodeScanner) {
    this._qrCodeScanner = value;
  }

  public get Diagnostic(): IDiagnostic {
    return this._diagnostic;
  }

  private _setDiagnostic(value: IDiagnostic) {
    this._diagnostic = value;
  }
}
